import React from 'react';
import ParticipantTracks from './ParticipantTracks';
import useVideoContext from '../hooks/useVideoContext';
import LocalParticipantInfo from './LocalParticipantInfo';
export default function LocalParticipant(_ref) {
  var videoProcessor = _ref.videoProcessor;

  var _useVideoContext = useVideoContext(),
      localParticipant = _useVideoContext.room.localParticipant;

  if (!localParticipant) {
    return null;
  }

  return /*#__PURE__*/React.createElement(LocalParticipantInfo, {
    videoProcessor: videoProcessor
  }, /*#__PURE__*/React.createElement(ParticipantTracks, {
    participant: localParticipant,
    disableAudio: true
  }));
}